import {get, post} from "@/axios/requestUtil";

export const getAppUserInfo = (token) => {
    return get("/tianyi/api/getAppUserInfo?token=" + token);
};
export const exchange = (token) => {
    return get("/tianyi/api/exchange?token=" + token);
};
export const getExchangeDetailList = (token) => {
    return get("/tianyi/api/getExchangeDetailList?token=" + token);
};
export const initAppUser = () => {
    return get("/tianyi/api/initAppUser");
};
export const getFlow = (token,fileType) => {
    return get("/tianyi/api/getFlow?token=" + token + "&fileType=" + fileType);
};
export const uploadFileToTinaYi = (param) => {
    return post("/tianyi/api/uploadFileToTinaYi",param);
};
export const accessToken = (param) => {
    return get("/cloudapi/open/oauth2/accessToken.action",param);
};
